module.exports = __webpack_public_path__ + "img/servicios05.496a6128.webp";